import { trackNavigationClick } from '@ecomm/cdp-tracking'
import { Link } from '@ecomm/framework'
import { getLogoLinkUrl } from '@ecomm/shared-cookies'
import { SimpliSafeLogo } from '@ecomm/shared-icons'
import classNames from 'classnames'
import { useTracking } from 'react-tracking'
import type { HeaderProps } from './types'

export function LogoLink({
  type,
  className = ''
}: { readonly type?: HeaderProps['type']; readonly className?: string }) {
  const { trackEvent } = useTracking()

  const logo = (
    <SimpliSafeLogo className="h-7 w-28 min-[1126px]:h-9 min-[1126px]:w-40" />
  )

  return type !== 'plain-with-no-link' ? (
    <Link
      aria-label="Home page"
      className={classNames(
        'ml-1 flex w-28 grow md:ml-[100px] md:grow-0 min-[1126px]:ml-0 min-[1126px]:w-[150px]',
        type !== 'full' && 'justify-center md:grow min-[1126px]:justify-start',
        type === 'slim' && 'ml-[75px]',
        className
      )}
      onClick={() => {
        trackEvent({
          event: 'navigation-link',
          eventAction: 'click',
          eventCategory: 'navigation',
          label: 'logo'
        })
        trackNavigationClick({
          action: 'click',
          navElement: 'logo'
        })
      }}
      to={getLogoLinkUrl('/')}
    >
      {logo}
    </Link>
  ) : (
    logo
  )
}
